import { render, staticRenderFns } from "./VideoBanner.vue?vue&type=template&id=8da8516e"
import script from "./VideoBanner.vue?vue&type=script&lang=js"
export * from "./VideoBanner.vue?vue&type=script&lang=js"
import style0 from "./VideoBanner.vue?vue&type=style&index=0&id=8da8516e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports